// @flow

import * as React from "react";
import { google, outlook, office365, ics } from "calendar-link";

import Modal from "../organisms/Modal";
import Icon from "../atoms/Icon";
import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    active: boolean,
    onClose: Function,
    calendarDetails: {
        title: string,
        location: string,
        description?: string,
        start: Date,
        end: Date,
    },
};

const AddToCalendarModal = (props: PropsType): React.Node => {
    return (
        <Modal
            aside={true}
            active={props.active}
            className="add-to-calendar-modal"
            onClose={props.onClose}
            onOverlayClick={props.onClose}
        >
            <Modal.Header>Add event to calendar</Modal.Header>
            <Modal.Content>
                <div className="add-to-calendar-modal__content__inner">
                    <LinkHandler
                        className="add-to-calendar-modal__cta"
                        target="blank"
                        to={outlook(props.calendarDetails)}
                    >
                        <div className="add-to-calendar-modal__cta__inner">
                            <span className="add-to-calendar-modal__cta__text">
                                Outlook Live calendar
                            </span>
                            <Icon name="chevron-right" />
                        </div>
                    </LinkHandler>

                    <LinkHandler
                        className="add-to-calendar-modal__cta"
                        target="blank"
                        to={office365(props.calendarDetails)}
                    >
                        <div className="add-to-calendar-modal__cta__inner">
                            <span className="add-to-calendar-modal__cta__text">
                                Outlook 365 calendar
                            </span>
                            <Icon name="chevron-right" />
                        </div>
                    </LinkHandler>

                    <LinkHandler
                        className="add-to-calendar-modal__cta"
                        target="blank"
                        to={google(props.calendarDetails)}
                    >
                        <div className="add-to-calendar-modal__cta__inner">
                            <span className="add-to-calendar-modal__cta__text">
                                Google calendar
                            </span>
                            <Icon name="chevron-right" />
                        </div>
                    </LinkHandler>

                    <a
                        className="add-to-calendar-modal__cta"
                        href={ics(props.calendarDetails)}
                    >
                        <div className="add-to-calendar-modal__cta__inner">
                            <span className="add-to-calendar-modal__cta__text">
                                Apple calendar
                            </span>
                            <Icon name="chevron-right" />
                        </div>
                    </a>
                </div>
            </Modal.Content>
        </Modal>
    );
};

export default AddToCalendarModal;
